// extracted by mini-css-extract-plugin
export default {"cell":"detailRow_cell__1wbB2","sub-cell":"detailRow_sub-cell__hCTIu"};